import { Reports } from "@graylog/enterprise-api";
import i18n from "i18n";
import fetchReports from "report/logic/fetchReports";
const isWidgetUsedInReports = async (widget, view, title) => {
  const reports = await fetchReports();
  const reportIds = await Reports.byWidgetId(view.id, widget.id);
  if ((reportIds == null ? void 0 : reportIds.length) === 1) {
    const reportId = reportIds[0];
    const inaccessibleReport = !reports[reportId];
    const reportTitle = inaccessibleReport ? reportId : `"${reports[reportId].title}"`;
    return window.confirm(
      i18n.t(inaccessibleReport ? "notifications.widget_single_inaccessible" : "notifications.widget_single", {
        ns: "enterprise_report",
        title,
        report_title: reportTitle
      })
    );
  }
  if ((reportIds == null ? void 0 : reportIds.length) > 1) {
    const reportTitles = reportIds.map((reportId) => {
      const inAccessibleReport = !reports[reportId];
      const reportTitle = inAccessibleReport ? reportId : `"${reports[reportId].title}"`;
      const notPermittedSuffix = inAccessibleReport ? i18n.t("notifications.report_not_permitted_title", { ns: "enterprise_report" }) : "";
      return `    - ${reportTitle}${notPermittedSuffix}`;
    }).join("\n");
    return window.confirm(
      i18n.t("notifications.widget_multiple", { ns: "enterprise_report", title, report_titles: reportTitles })
    );
  }
  return null;
};
export default isWidgetUsedInReports;
